import { render, staticRenderFns } from "./WInlineText.vue?vue&type=template&id=0d3835e1&scoped=true&"
import script from "./WInlineText.vue?vue&type=script&lang=js&"
export * from "./WInlineText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3835e1",
  null
  
)

export default component.exports